import React from 'react';

const IngestionTopLoader = ({ percentage }) => {
  return (
    <div className="absolute top-0 left-0 w-full h-[4px] bg-slate-300/90 border-b border-slate-400/70 z-20">
      {/* Fill */}
      <div
        className="h-full transition-all duration-300 ease-out relative"
        style={{ backgroundColor: 'hsl(var(--muted-foreground))', width: `${percentage}%` }}
      >
        {/* Leading glow — use inline style since gradient with CSS var won't work in Tailwind */}
        <div
          className="absolute right-0 top-0 h-full w-12 opacity-70"
          style={{ background: 'linear-gradient(to right, transparent, hsl(var(--muted-foreground)))' }}
        />
      </div>

      {/* Percentage bubble anchored to leading edge */}
      <div
        className="absolute top-[3px] -translate-x-1/2 transition-all duration-300 ease-out"
        style={{ left: `${Math.min(Math.max(percentage, 3), 97)}%` }}
      >
        {/* Triangle — inline style because border-color can't use CSS vars via Tailwind */}
        <div
          className="mx-auto w-0 h-0 border-l-4 border-r-4 border-b-4 border-l-transparent border-r-transparent"
          style={{ borderBottomColor: 'hsl(var(--primary))' }}
        />
        <div
          className="px-2 py-[2px] text-[10px] font-semibold rounded-full shadow-lg whitespace-nowrap"
          style={{
            backgroundColor: 'hsl(var(--primary))',
            color: 'hsl(var(--primary-foreground))'
          }}
        >
          {Math.floor(percentage)}%
        </div>
      </div>
    </div>
  );
};

export default IngestionTopLoader;